import { Component } from '@angular/core';
import { NtapGlobalConstants, Util } from '@ntap/core';
import { map } from 'rxjs';
import { ItemsListActionComponent } from './items-list-action/items-list-action.component';

@Component({
  selector: 'app-activate-deactivate-list-items',
  templateUrl: '../../shared/components/actions/common-action-template.html'
})
export class ActivateDeactivateListItemsActionComponent extends ItemsListActionComponent {
  protected override initDisabledObservable(): void {
    this.isDisabled$ = this.listViewProvider.selectedItems$.pipe(
      map((selectedItems) => {
        const allSelectedDisabled = selectedItems.every((item: any) => {
          const mainType =
            item[NtapGlobalConstants.ATTR_$itemType] ||
            item[NtapGlobalConstants.ATTR_$mainType];
          const statusValue =
            item[Util.getFullAttrName(mainType, 'enabled')] ||
            item[Util.getFullAttrName(mainType, 'status')];
          return (
            statusValue === 'I' || statusValue === 'Neaktivan' || !statusValue
          );
        });
        const allSelectedEnabled = selectedItems.every((item: any) => {
          const mainType =
            item[NtapGlobalConstants.ATTR_$itemType] ||
            item[NtapGlobalConstants.ATTR_$mainType];
          const statusValue =
            item[Util.getFullAttrName(mainType, 'enabled')] ||
            item[Util.getFullAttrName(mainType, 'status')];
          return (
            statusValue === true ||
            statusValue === 'Aktivan' ||
            statusValue === 'A'
          );
        });
        this.action.description =
          selectedItems.length > 0
            ? allSelectedEnabled
              ? 'Deaktiviraj'
              : allSelectedDisabled
              ? 'Aktiviraj'
              : 'Aktiviraj / Deaktiviraj'
            : 'Aktiviraj / Deaktiviraj';
        return (
          selectedItems.length == 0 ||
          !(allSelectedDisabled || allSelectedEnabled)
        );
      })
    );
  }
}
